import { render } from "./SidebarComponent.vue?vue&type=template&id=63407b64&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=63407b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63407b64"]])

export default __exports__